import { END_OF_TRIAL_MESSAGE_AUDIENCES } from './constants';

export const getEndOfTrialMessageAudience = (preDunningDaysLeft: number) => {
	if (preDunningDaysLeft >= 0 && preDunningDaysLeft <= 13) {
		return END_OF_TRIAL_MESSAGE_AUDIENCES[preDunningDaysLeft];
	}

	return undefined;
};
